import store from '~/store'

export default (to, from, next) => {
  if (store.getters['auth/check'].role !== 'recipient') {
    next({ name: 'home' })
  } else {
    next({ name: 'evaluations' })
  }
}



// WEBPACK FOOTER //
// ./resources/js/middleware/recipient.js